import { Overlay, Loading } from 'vant';
export default {
  props: {
    isShowLoading: Boolean
  },
  components: {
    [Overlay.name]: Overlay,
    [Loading.name]: Loading
  }
};